angular.module('component-payments.validate', [
	require('./cvc'),
	require('./expire'),
	require('./name'),
	require('./number')
]);

module.exports = 'component-payments.validate';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/validators/index.js
 ** module id = 100
 ** module chunks = 1
 **/